import { ArrayMinSize, IsArray, IsBoolean, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { Type } from 'class-transformer';

export class CreateNewsfeedDto {
  @ApiProperty({
    description: 'The title of the newsfeed',
    example: 'Important Announcement'
  })
  @IsNotEmpty()
  @IsString()
  title: string;

  @ApiProperty({
    description: 'The subject of the newsfeed',
    example: 'Company Update'
  })
  @IsNotEmpty()
  @IsString()
  subject: string;

  @ApiProperty({
    description: 'The images of the newsfeed',
    example: ['https://example.com/image1.jpg']
  })
  @IsOptional()
  files?: [];

  @ApiProperty({
    description: 'The detailed description of the newsfeed',
    example: 'We are excited to announce our new features...',
    required: false
  })
  @IsOptional()
  @IsString()
  description?: string;

  @ApiProperty({
    description: 'The audio of the newsfeed',
    example: 'https://example.com/audio.mp3',
    required: false
  })
  @IsOptional()
  audio?: string;

  @ApiProperty({
    description: 'The tags or keyword for search and categorization',
    example: ['company', 'update'],
  })
  @IsArray()
  @ArrayMinSize(1)
  tags: string[];

  @ApiProperty({
    description: 'Allow live edit',
    example: true
  })
  @IsNotEmpty()
  @IsBoolean()
  is_live_edit: boolean;

  @ApiProperty({
    description: "Make newsfeed public or private",
    example: false
  })
  @IsNotEmpty()
  @IsBoolean()
  is_public: boolean;
}
